<script>
  import { Popup, Block, Row, FileInput, Text, Icon, Column, Image } from 'bastone'
  import MyButton from './button.svelte'
  import { colors, fileBaseUrl } from '../consts'
  import { currentUser, notify } from '../context'
  import { ApiClient } from '../models'
  import { upload } from '../utils'

  export let showing = false
  export let uploadFileUrl = ''
  export let uploadDone = async()=>{}

  let fileInput = null
  let file = null
  let uploadToken = ''
  let errorMessage = ''
  let uploading = false


  async function uploadData() {
    if (!file) {
      errorMessage = '尚未选择文件'
      return
    }

    uploadToken = await ApiClient.getUploadToken()
    if (uploadToken === null) {
      errorMessage = '获取上传token失败'
      return
    }

    if (file.size > 5 * 1024 * 1024) {
      errorMessage = '文件大小不能超过5MB'
      return
    }

    let key = `upload/${Date.now()}_${$currentUser.id}_${file.name}`
    upload(file, key, uploadToken, async (res)=>{
      uploadFileUrl = fileBaseUrl + key
      await uploadDone(file, uploadFileUrl)
      uploading = false
    })
  }

  function selectFile() {
    if (fileInput.files.length < 1) {
      return
    }
    if (fileInput.files[0].size > 5 * 1024 * 1024) {
      errorMessage = '文件大小不能超过5MB'
      return
    }
    file = fileInput.files[0]
  }

  function reset() {
    fileInput.files = null
    file = null
    errorMessage = ''
  }

</script>


<Popup {showing} clickDismiss={false}>
  <Block width=36rem padding={{horizontal:'1.5rem'}} backgroundColor=white lineHeight=1.6rem>
    <Block height=1.2rem/>
    <Row height=1.2rem xAlign=flex-start>
      <Text bold=1 size=1.2rem>上传数据集</Text>
      <Block expand=1/>
      <Icon name=close size=1.4rem cursor=pointer on:click={()=>{reset();showing=false}}/>
    </Row>
    <Block height=1rem/>

    <Row>
      <FileInput blockProps={{
        width:'100%',height:'7rem',hoverBgColor:colors.snow,
        border:'2px dashed darkgray',borderRadius:'0.5rem',padding:'1rem'}}
        bind:input={fileInput} accept=".txt,.pdf" on:change={selectFile}
      >
        <Column width=100% height=100% align=center xAlign=center>
          {#if !file}
          <Block height=0.3rem/>
          <Image url='/images/upload.png' height=2.4rem/>
          <Block height=0.5rem/>
          <Text wrap=1>点击/拖拽上传，大小5MB以内</Text>
          {:else}
          <Text wrap=1>{file.name}({(file.size/1048576).toFixed(2)}MB)</Text>
          <Block height=0.5rem/>
          <Row>
            <MyButton 
              border=1 height=1.8rem width=6rem bold={false} fill=1
              icon=upload iconSize=1rem space=0.3rem
              on:click={e=>{e.stopPropagation();uploadData()}}
            >确定上传</MyButton>
            <Block width=0.5rem/>
            <MyButton 
              border=1 height=1.8rem width=4rem bold={false}
              icon=refresh iconSize=1rem space=0.3rem
              on:click={e=>{e.stopPropagation();reset()}}
            >重置</MyButton>
          </Row>
          {/if}
        </Column>
      </FileInput>
    </Row>

    <Block height=1rem/>
    <Text wrap=1>文件类型：<b>TXT/PDF</b>，PDF文字需可复制，其他文本文件改成TXT即可</Text>
    <Text wrap=1>内容格式：程序会自动切割。建议每行一个知识点，首句为标题/问题</Text>
    <Text wrap=1>长度限制：BOT数据集最多存储3000段文本(约100W字)，超过后将中止</Text>
    {#if errorMessage}
    <Block height=0.6rem/>
    <Text color={colors.red} wrap=1>{errorMessage}</Text>
    {/if}
    <Block height=1.2rem/>
  </Block>
</Popup>